import React, { ReactElement } from "react";
import styles from "./questionSideCta.module.scss";
import { useTranslation } from "next-i18next";
import SocialAuthButtonProvider from "../socialAuthButtonProvider";
import {
  AppleSigninButton,
  GoogleSigninButton,
} from "@kunduz/feature-onboarding";
import { useRouter } from "next/router";
import { AUTH_PAGEURLS } from "@kunduz/utility-common";

const SignupSocialSidebarCta = (props: Props): ReactElement => {
  const { t } = useTranslation("questionIndexing");
  const router = useRouter();

  function handleLoginClick() {
    if (typeof window !== "undefined") {
      if (router.asPath.includes("/blog/") && router.locale === "tr") {
        window.location.href = `${AUTH_PAGEURLS.B2C_SELECT_LOGIN_METHOD}?returnUrl=/tr${router.asPath}`;
        return;
      } else if (
        router.asPath.includes("/soru-cozum/") &&
        router.locale === "tr"
      ) {
        window.location.href = `${AUTH_PAGEURLS.B2C_SELECT_LOGIN_METHOD}?returnUrl=/tr${router.asPath}`;
        return;
      } else {
        window.location.href = `${AUTH_PAGEURLS.B2C_SELECT_LOGIN_METHOD}?returnUrl=${router.asPath}`;
      }
    }
  }

  if (props.isMobile) {
    return (
      <div className={styles.signupSocialMobile}>
        <div
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: props.mobileTitle }}
        />
        <div className={styles.description}>{props.mobileSubtitle}</div>
        <SocialAuthButtonProvider type="google" location="Sidebar">
          <GoogleSigninButton
            label={t("google_signup_button_label")}
            className={styles["fullWidth"]}
          />
        </SocialAuthButtonProvider>
      </div>
    );
  }

  return (
    <div className={styles.signupSocial}>
      <div
        className={styles.title}
        dangerouslySetInnerHTML={{
          __html: props.propositionTitle,
        }}
      />

      <ul className={styles.list}>
        <li>{props.propositionText1}</li>
        <li>{props.propositionText2}</li>
        <li>{props.propositionText3}</li>
        <li>{props.propositionText4}</li>
      </ul>
      <SocialAuthButtonProvider type="google" location="Sidebar">
        <GoogleSigninButton
          label={t("google_signup_button_label")}
          className={styles["fullWidth"]}
        />
      </SocialAuthButtonProvider>
      <SocialAuthButtonProvider type="apple" location="Sidebar">
        <AppleSigninButton
          label={t("apple_signup_button_label")}
          className={styles["fullWidth"]}
        />
      </SocialAuthButtonProvider>
      <div
        className={styles.secondaryCta}
        onClick={handleLoginClick}
        dangerouslySetInnerHTML={{
          __html: t(
            "question_indexing_sidebar_component_signup_state_login_text",
          ),
        }}
      />
      <div
        className={styles.disclaimer}
        dangerouslySetInnerHTML={{
          __html: t(
            "question_indexing_sidebar_component_signup_state_disclaimer_text",
          ),
        }}
      />
    </div>
  );
};

interface Props {
  lang: "tr" | "en";
  isMobile: boolean;
  propositionTitle: string;
  propositionText1: string;
  propositionText2: string;
  propositionText3: string;
  propositionText4: string;
  mobileTitle: string;
  mobileSubtitle: string;
}

export default SignupSocialSidebarCta;
